"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Dialog, Button } from "@mui/material";
import Image from "next/image";
const SuccessModal = t0 => {
  const $ = _c(23);
  const {
    open,
    onClose,
    onOkay,
    contractorName
  } = t0;
  let t1;
  if ($[0] !== onClose || $[1] !== onOkay) {
    t1 = () => {
      if (onOkay) {
        onOkay();
      } else {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = onOkay;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOkay = t1;
  let t2;
  if ($[3] !== onClose) {
    t2 = (event, reason) => {
      if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
      }
      onClose();
    };
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paper: {
        sx: {
          width: "312px",
          height: "374px",
          minWidth: "280px",
          maxWidth: "560px",
          borderRadius: "28px",
          background: "var(--colorSurfaceSurface, #FFFFFF)",
          padding: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          "@media (max-width: 600px)": {
            width: "calc(100vw - 32px)",
            maxWidth: "560px",
            minWidth: "280px",
            height: "auto",
            minHeight: "374px"
          }
        }
      },
      backdrop: {
        sx: {
          backdropFilter: "blur(4px)"
        }
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col items-center justify-center flex-shrink-0 pt-6"><div className="relative w-24 h-24"><Image src="/icons/success-gif-icon.gif" alt="Success" fill={true} className="object-contain" unoptimized={true} /></div></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem",
      paddingTop: "1.5rem"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="m3-headline-small text-center w-full" style={{
      color: "var(--textPrimaryPrimary, #1B1C17)",
      marginBottom: "1rem"
    }}>Enquiry sent</h2>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      color: "var(--textSecondarySecondary, #5E5F59)"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== contractorName) {
    t8 = <div className="flex flex-col items-center flex-1 w-full" style={t5}>{t6}<p className="m3-body-medium text-center w-full" style={t7}>{contractorName} will reach out to you within 24 hours.</p></div>;
    $[10] = contractorName;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: "var(--textLinkOnSurfaceLink, #004BEE)",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "rgba(0, 75, 238, 0.04)"
      }
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== handleOkay) {
    t11 = <div className="flex flex-row justify-end items-center flex-shrink-0 w-full pb-6" style={t9}><Button onClick={handleOkay} variant="text" className="m3-label-large" sx={t10}>Okay</Button></div>;
    $[14] = handleOkay;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t8) {
    t12 = <div className="flex flex-col items-center w-full h-full min-h-[374px]">{t4}{t8}{t11}</div>;
    $[16] = t11;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== open || $[20] !== t12 || $[21] !== t2) {
    t13 = <Dialog open={open} onClose={t2} maxWidth="sm" slotProps={t3}>{t12}</Dialog>;
    $[19] = open;
    $[20] = t12;
    $[21] = t2;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
export default SuccessModal;